import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import FlightSelection from "../components/FlightSelection/FlightSelection";
import PassengerSelection from "../components/PassengerSelection/PassengerSelection";
import SSROutlet from "../SSROutlet";
import SSRSelection from "../components/SSRSelection/SSRSelection";
import SSRDisclaimers from "../components/SSRDisclaimers/SSRDisclaimers";
import SSRSummary from "../components/SSRSummary/SSRSummary";

const SSRWeb: FC<{ stepButtons: ReactNode }> = ({ stepButtons }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex w-full flex-col gap-4">
        <div className="flex w-full flex-col justify-between gap-4 lg:flex-row lg:items-center">
          <div className="flex flex-col">
            <div className="text-lg font-bold md:text-2xl">{t("Flights.details.steps.extraSelections")}</div>
            <div className="text-font-minimal text-xs font-semibold md:text-sm">{t("Flights.details.steps.extraSelectionsSubtitle")}</div>
          </div>
          <div>
            <SSRSelection />
          </div>
        </div>
        <div className="bg-background-default max-h-120 flex w-full flex-col gap-4 overflow-y-auto rounded-md p-4">
          <FlightSelection />
          <div className="flex w-full flex-col items-start justify-between gap-x-8 gap-y-4 md:flex-row md:flex-wrap">
            <div className="md:flex-1 w-full md:sticky md:top-0">
              <PassengerSelection />
            </div>
            <div className="md:flex-2 w-full min-w-[15rem]">
              <SSROutlet />
            </div>
            <div>
              <SSRDisclaimers />
            </div>
          </div>
        </div>
        <SSRSummary stepButtons={stepButtons} />
      </div>
    </>
  );
};

export default SSRWeb;
